var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-preloader-view",class:{finished: _vm.finish}},[_c('i',{staticClass:"spinner"})])}
var staticRenderFns = []

export { render, staticRenderFns }